import './index.css'

import React from 'react'
import placeholder from 'assets/images/playlist-showcase-placeholder.png'
import AspectRatio from 'components/ui/aspect-ratio'
const STAR_ICON: React.ReactNode = (
  <svg
    className="PlaylistShowcaseArtwork-star"
    fill="currentcolor"
    width="12"
    height="12"
  >
    <path
      d="M5.994 0A5.997 5.997 0 0 0 0 6c0 3.312 2.682 6 5.994 6A6.003 6.003 0 0 0 12 6c0-3.312-2.688-6-6.006-6Zm2.544 9.6L6 8.07 3.462 9.6l.672-2.886-2.238-1.938 2.952-.252L6 1.8l1.152 2.718 2.952.252-2.238 1.938.672 2.892Z"
      fill="url(#a)"
    />
  </svg>
)

/**
 * PlaylistShowcaseArtwork component for displaying featured playlist artwork
 *
 * A specialized artwork component that displays a placeholder image with a star icon
 * overlay, designed for showcase or featured playlist presentations. Uses a 1:1 aspect ratio.
 *
 * @returns JSX element containing the showcase artwork with star overlay
 */
const PlaylistShowcaseArtwork = (): React.ReactElement<'div'> => (
  <div className="PlaylistShowcaseArtwork">
    <AspectRatio image={placeholder} ratio={1}>
      {STAR_ICON}
    </AspectRatio>
  </div>
)

export default PlaylistShowcaseArtwork
